"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areFieldsNotNil = exports.isNotNil = exports.ok = exports.error = void 0;
const lodash_1 = __importDefault(require("lodash"));
const error = (payload) => ({
    type: 'error',
    payload,
});
exports.error = error;
const ok = (value) => ({
    type: 'success',
    value,
});
exports.ok = ok;
const isNotNil = (value) => lodash_1.default.negate(lodash_1.default.isNil)(value);
exports.isNotNil = isNotNil;
const areFieldsNotNil = (fields) => (input) => fields.every((f) => (0, exports.isNotNil)(input[f]));
exports.areFieldsNotNil = areFieldsNotNil;
